import React, {Suspense} from "react";
import {FullLoading} from "../../core/components/loading";
import RootHeader from "./header";
import RenderIf from "../../core/components/render-if";

const RootLayout = ({title,children,navigateTo, haveHeader = true, haveHumberMenu = true}) => {
    return (
        <>
            <RenderIf cond={haveHeader}>
                <RootHeader title={title} haveHumberMenu={haveHumberMenu} navigateTo={navigateTo}/>
            </RenderIf>
            <div className="bg-purple-6">
                <Suspense fallback={<FullLoading/>}>
                    <div className="mx-auto flex min-h-[100svh] flex-col lg:px-52">
                        {children}
                    </div>
                </Suspense>
            </div>
        </>
    );
};

export default RootLayout;
